// Global Instructions Rule Applied!
export const SET_EXECUTION_BOARD = 'deal_execution/SET_EXECUTION_BOARD'
export const UPDATE_EXECUTION_BOARD_ROW = 'deal_execution/UPDATE_EXECUTION_BOARD_ROW'
export const MARK_EXECUTION_BOARD_STALE = 'deal_execution/MARK_EXECUTION_BOARD_STALE'
